// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__wC1x1","btnOffer":"AddProduct_btnOffer__DwQLc"};